export default __webpack_public_path__ + "static/media/pemeringkatan-logo.73d3c7b2.png";